import React, { FunctionComponent } from "react";
import styled from "styled-components";

import SPEAKERS from "@/utils/step-forward-speakers";
import { colours } from "utils";
import Device from "@/utils/device";
import StepForwardTitle from "../step-forward/StepForwardTitle";
import SpeakerImage from "./SpeakerImage";

const LineUpContent: FunctionComponent = () => {
  return (
    <S.Section data-cy="SF-content-speakers">
      <StepForwardTitle>This Year's Speakers Include</StepForwardTitle>
      <S.SpeakersContainer>
        {SPEAKERS.map((speaker) => (
          <SpeakerImage {...speaker} key={speaker.name} />
        ))}
      </S.SpeakersContainer>
    </S.Section>
  );
};

const S = () => {};

S.Section = styled.section`
  position: relative;
  width: 100%;
  padding: 10%;
  background: ${colours.shell};

  @media ${Device.tablet} {
    padding: 5% 10%;
  }
`;

S.SpeakersContainer = styled.div`
  margin: 40px 0 0 0;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-gap: 20px;

  @media ${Device.mobile} {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    grid-gap: 30px;
  }

  @media ${Device.tablet} {
    margin: 60px 0 0 0;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    grid-gap: 20px;
  }

  @media ${Device.desktop} {
    grid-gap: 40px;
  }
`;

export default LineUpContent;
